import { queryStringify } from '@utils'
import { createMutationHelper } from '@utils/swr'
import { type CampaignGetCouponIdByCodeRequest } from '../types/apiRequest'
import { type CampaignGetCouponIdByCodeResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['get']['campaignCouponCode'], CampaignGetCouponIdByCodeResponse, CampaignGetCouponIdByCodeRequest>({
  client: 'fortune',
  key: 'campaigns/:campaign_code/coupons/coupon_code/:coupon_code',
  fetcher: (_, { client, arg }) => {
    if (!arg.project_code || !arg.campaign_code || !arg.coupon_code) {
      return Promise.reject(new Error('[useApiCampaignGetCouponIdByCode] project_code, campaign_code and coupon_code are required!'))
    }
    return client.get(`/campaigns/${arg.campaign_code}/coupons/coupon_code/${arg.coupon_code}?${queryStringify({
      project_code: arg.project_code,
      merchant_id: arg.merchant_id,
    }, { skipNull: true })}`)
  },
})

export const useApiCampaignGetCouponIdByCode = useMutation
